export const CONSENT_KEY = 'bl_cookie_consent';

export type CookieConsent = 'all' | 'essential';

export function getConsent(): CookieConsent | null {
  const value = localStorage.getItem(CONSENT_KEY);
  if (value === 'all' || value === 'essential') return value;
  return null;
}

export function acceptAll(): void {
  localStorage.setItem(CONSENT_KEY, 'all');
}

export function acceptEssential(): void {
  localStorage.setItem(CONSENT_KEY, 'essential');
}
